// extracted by mini-css-extract-plugin
export default {"rightbordershadow":"TenderPayouts_rightbordershadow__I6Pfk"};